import type { Props } from "~/components/cart/QuantityIndicator"
import { lazy, Suspense } from "react"
import { useLoadedOnMouseMove } from "~/sdk/useUI"

const QuantityIndicator = lazy(() => import('~/components/cart/QuantityIndicator'))

/**
 * Cart-count badge. The signal `loadedOnMouseMove` flips to true once the
 * page has loaded (see `sdk/useUI.ts`), which gates lazy-loading the actual
 * QuantityIndicator until after first paint.
 *
 * The previous version read `display.value` directly — that returns the
 * current signal value but does NOT subscribe via `useStore`, so this
 * component never re-rendered when `loadedOnMouseMove` flipped, and the
 * badge never appeared. `useLoadedOnMouseMove()` is the reactive read.
 */
export default function Indicator(props: Props) {
    const loaded = useLoadedOnMouseMove()

    return (
        <Suspense
            fallback={
                <div className='bg-salmon rounded-full text-white text-xs w-5 h-5 flex justify-center items-center'>
                    <span className='loading loading-spinner loading-xs' />
                </div>
            }
        >
            {loaded && <QuantityIndicator {...props} />}
        </Suspense>
    )
}
